<div class="image-panel">
  <h2 class="image-border image-border-block" [class]="topClass()">
    <ng-content select="[imagePanelTop]" />
  </h2>

  <div class="page-image-div">
    <img [class]="imageClass()" [src]="imageSrc()" [alt]="imageAlt()" />
  </div>

  <h2 class="image-border image-border-block" [class]="bottomClass()">
    <ng-content select="[imagePanelBottom]" />
  </h2>
</div>
